import { ButtonWidget } from '@tableau/widgets';
import React from 'react';

import { cssClass } from '../../style';

const cssPrefix = 'Information';

const rootClass = cssClass(cssPrefix, 'root',  {
  overflow: 'auto',
  width: '300px',
  height: '20px',
  justifyContent: 'space-between',
  display: 'inline',
});

const spanStyleClass = cssClass(cssPrefix, 'span-style', {
  $nest: {
    'span': {
      color: 'white',
      letterSpacing: '0.2px',
      fontWeight: 'normal',
      fontSize: '14px',
      paddingRight: '4px',
      $nest: {
        '&:last-child': {
          paddingRight: '8px'
        }
      }
    }
  }
});

const buttonStyle: React.CSSProperties = {
  color: 'white',
  backgroundColor: '#FF6D02',
  fontSize: '11px',
  height: '32px',
  borderRadius: '100px',
  fontFamily: '"Benton Sans Medium",Helvetica,sans-serif',
  textTransform: 'uppercase'
};

const replaceAt = (indexArray: number[], wordArray: (string | JSX.Element)[]): (string | JSX.Element)[] => {
  const replaceValue = (i: number) =>
    (wordArray[i] = (
      <b>
        {wordArray[i]}
      </b>
    ));
  indexArray.forEach(replaceValue);
  return wordArray;
};

export class InformationBox extends React.Component<InformationBox.Props, any> {

  static element = React.createFactory(InformationBox);

  public render() {
    const wordList = replaceAt([2], this.props.message.split(' '));
    if (this.props.display) {
      return (
        <div>
          {attachTags(wordList)}
          <ButtonWidget
            children={this.props.actionMessage}
            handleClick={this.props.action}
            style={buttonStyle}
            testId={'buy-more-button-td-testId'}
          />
        </div>
      );
    }
  }
}

function attachTags(wordArray: (string | JSX.Element)[]) {
  return (
    <span className={spanStyleClass}>
      {wordArray.map((word, idx) => (
      <span key={word as string} >{word}</span>
    ))}
    </span>
  );
}

export module InformationBox {

  export interface Props {
    display: boolean;
    action?: () => void;
    message: string;
    actionMessage: string;
  }

}